import styled from "styled-components";
import { CenterFlexColumn } from "styles/layout";

export const TimeText = styled(CenterFlexColumn)`
  row-gap: 2px;
  @media (max-width: 600px) {
    font-size: 10.5pt;
  }
`;
